import { useEffect, useRef } from "react"
import { gsap } from 'gsap';

const AnimatedIcon = ({start, timeout, node}) => {
  const meshRef = useRef();

  useEffect(() => {
    startAnim()
  }, [])

  const startAnim = () => {
    const mesh = meshRef.current;

    if (!mesh) return;

    // GSAP анімація: підняти вверх, потім повернути назад
    setTimeout(() => {
      gsap.timeline()
        .to(mesh.position, { x: -14.16, duration: 0.5 })
        .to(mesh.rotation, { y: mesh.rotation.y + Math.PI * 2, duration: 1 })
        .to(mesh.position, { x: -14.26, duration: 0.5 });
    }, timeout)
  }

  return (
    <mesh
      ref={meshRef}
      position={[-14.26, 2.2, start]} // Встановлення позиції позаду тексту
      scale={[1, 1, 1]} // Розмір блока
      rotation={[0, Math.PI, 0]}
    >
      <primitive object={node} />
    </mesh>
  )
}

export {
  AnimatedIcon
}
